import autocomplete from "@/components/autocomplete/index.vue";
import { mapActions, mapGetters, mapMutations } from "vuex";

export default {
    name: "delivery-nova-poshta",
    inject: ["$v"],
    data() {
        return {
            town: "",
            department: "",
            isValid: false,
            isValidTown: false,
            isValidDepartment: false,
        };
    },
    components: {
        autocomplete,
    },
    computed: {
        ...mapGetters({
            towns: "order/towns",
            user: "profile/user",
            addressData: "order/address",
            departments: "order/departments",
        }),
    },
    watch: {
        town() {
            const currentTown = this.towns.find(e => e.Description === this.town);
            this.department = "";

            if (!currentTown) {
                return;
            }

            if (this.town === currentTown.Description) {
                this.onRequestDepartments("");
            } else {
                this.setDepartments([]);
            }
        },
        department() {
            this.checkValidData();
        },
    },
    created() {
        this.onRequestTown(this.town);
        this.onRequestDepartments("");
    },
    methods: {
        ...mapActions({
            fetchTowns: "order/NOVA_POSHTA_GET_TOWNS",
            fetchDepartments: "order/NOVA_POSHTA_GET_DEPARTMENS",
        }),
        ...mapMutations({
            setDepartments: "order/NOVA_POSHTA_SET_DEPARTMENS",
            changeAddress: "order/CHANGE_USER_ADDRESS",
        }),
        onRequestTown(val) {
            const formData = JSON.stringify({
                modelName: "Address",
                calledMethod: "getCities",
                methodProperties: {
                    FindByString: val,
                },
                apiKey: "a7d93153439a6d348d0abd17ca50c53b",
            });
            this.fetchTowns(formData).then(() => {
                const currentTown = this.towns.find(e => e.Description === this.town);
                this.department = "";

                if (!currentTown) {
                    return;
                }

                if (this.town === currentTown.Description) {
                    this.onRequestDepartments("");
                } else {
                    this.setDepartments([]);
                }
                this.checkValidData();
            });
        },
        onRequestDepartments(val) {
            const formData = JSON.stringify({
                modelName: "AddressGeneral",
                calledMethod: "getWarehouses",
                methodProperties: {
                    CityName: this.town,
                    FindByString: val,
                    Language: "ua",
                },
                apiKey: "a7d93153439a6d348d0abd17ca50c53b",
            });
            this.fetchDepartments(formData).then(() => {
                this.checkValidData();
            });
        },
        checkValidData() {
            const currentTown = this.towns.find(e => e.Description === this.town);
            if (currentTown) {
                this.isValidTown = this.town === currentTown.Description && this.town.length !== 0;
            } else {
                this.isValidTown = false;
            }

            const currentDepartment = this.departments.find(e => e.Description === this.department);
            if (currentDepartment) {
                this.isValidDepartment =
                    this.department === currentDepartment.Description && this.department.length !== 0;
            } else {
                this.isValidDepartment = false;
            }

            this.isValid = this.isValidTown && this.isValidDepartment;
            let userAddress = {};
            userAddress.town = this.town;
            userAddress.department = this.department;
            userAddress.status = this.town !== "" && this.department !== "";
            this.changeAddress(userAddress);
            this.$emit("input", this.isValid);
        },
    },
};
